import React from 'react';
import './App.css';
import Row from './Row';
import requests from './requests';
import Banner from './Banner';
import Nav from './Nav';

function App() {
  return (
    <div className="App">
    <Nav />
    <Banner />
    <Row title="Netflix Originals" fetchUrl={requests.fetchNetflixOrignials} isLargeRow/>    
    <Row title="Trending Now" fetchUrl={requests.fetchTrending}/>
    <Row title="Top Rated" fetchUrl={requests.fetchTopRated}/>
    <Row title="Comedy " fetchUrl={requests.fetchComedyMovies}/>
    <Row title="Animation " fetchUrl={requests.fetchAnimation}/>
    <Row title="Romance " fetchUrl={requests.fetchRomanceMovies}/>
    <Row title="Crime" fetchUrl={requests.fetchCrime}/>
    <Row title="Drama" fetchUrl={requests.fetchDrama}/>
    <Row title="Documentaries" fetchUrl={requests.fetchDocumentaries}/>
    
    </div>
    
  );
}

export default App;
